module.exports = __webpack_public_path__ + "media/images/cover/room-glass-929ac9e643f062676084c6ae82aacb50.jpeg";